import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Checkbox, FormField } from '@legalshield/adonis-ux-framework';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  required?: boolean;
};

const CheckboxField = <T extends FieldValues>({ control, name, label, required }: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <FormField
        id={String(name)}
        required={required}
        status={fieldState.error ? 'invalid' : undefined}
        validationHint={fieldState.error?.message}
      >
        <Checkbox
          name={String(name)}
          rightLabel={label}
          checked={Boolean(field.value)}
          onChange={() => field.onChange(!field.value)}
        />
      </FormField>
    )}
  />
);

export default CheckboxField;
